import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { AutomationEvent } from '../../models/automation-events.enum';

export interface AutomationEventPayload {
  event: AutomationEvent;
  context: any; // eslint-disable-line @typescript-eslint/no-explicit-any
}

@Injectable({
  providedIn: 'root'
})
export class AutomationEventService {

  private eventSubject = new Subject<AutomationEventPayload>();

  /**
   * Observable for other services to subscribe to automation events.
   */
  get events$(): Observable<AutomationEventPayload> {
    return this.eventSubject.asObservable();
  }

  constructor() { }

  /**
   * Publishes an automation event to all listeners.
   * @param event The type of event, from the AutomationEvent enum.
   * @param context An object containing relevant data for the event (e.g., { caseId: '...' }).
   */
  publish(event: AutomationEvent, context: any): void { // eslint-disable-line @typescript-eslint/no-explicit-any
    this.eventSubject.next({ event, context });
  }
}
